import React, {ReactElement} from "react";
import {Box, Grid, styled} from "@mui/material";
import MediaCard from "../card/MediaCard";
import {IProjectPage} from "../../interfaces/components/pages/projects/IProjectPage";
import DescriptionText from "../typography/DescriptionText";
import {ILanguageTokens} from "../../localization/LanguageTokens";
import {RootState} from "../../redux/store";
import {connect} from "react-redux";

const GridList = styled(Grid)(({theme}) => ({
    width: 'auto',
    placeContent: 'center',
}));

interface IProps {
    projectPages: IProjectPage[];
    languageTokens: ILanguageTokens;
}

function ImageGrid({projectPages, languageTokens}: IProps): ReactElement {

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
        }}>
            <DescriptionText text={languageTokens.personalProjectsDescription}/>
            <GridList id={'ImageGrid'} container gap={2}>
                {projectPages.map((project, index) => (
                    <MediaCard
                        key={`${project.mediaCardElement.name}_${index}`}
                        mediaCardElement={project.mediaCardElement}
                    />
                ))}
            </GridList>
        </Box>
    );
}

const mapStateToProps = (state: RootState) => ({
    languageTokens: state.language.languageTokens,
});

const mapActionsToProps = {};

export default connect(mapStateToProps, mapActionsToProps)(ImageGrid);
